import React, { Fragment } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';



const ProductAndCategorySlider = ({ values, responsive }) => {
    return (
    <Carousel 
    responsive={responsive}
    swipeable={true}
    infinite={true}
    showDots={values.length > 1 ? true: false}>
        {values.map((value, index) => (
            
            <Fragment key={"product-slider-fg"+index}>
            <div className="product-category__outer" key={`figure${index}`}>
                <a className="product-category__link" href={value.url} aria-label={value.text} role='Link'>
                    <div className="product-category__image--outer" dangerouslySetInnerHTML={{ __html: value.image }}></div>
                </a>
                {value.text ? (<div><h3>{value.text}</h3></div>): ''}
                
            </div>
            </Fragment>
        ))}
    </Carousel>
)};

export default ProductAndCategorySlider;
